import React from "react";
import { useSearchParams, Link } from "react-router-dom";

export default function Success() {
  const [params] = useSearchParams();
  const order = params.get("order");

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md w-full rounded-3xl border p-8 text-center"
           style={{ background: 'var(--background2)', borderColor: 'var(--border)' }}>
        <h1 className="text-2xl font-bold mb-3" style={{ color: 'var(--foreground)' }}>
          تم إرسال الطلب ✅
        </h1>
        {order && (
          <p className="mb-4" style={{ color: 'var(--foreground2)' }}>
            رقم الطلب: <span className="font-semibold">{order}</span>
          </p>
        )}
        <p className="mb-8" style={{ color: 'var(--foreground2)' }}>
          شكراً لك! تم استلام بياناتك بنجاح.
        </p>
        <Link to="/" className="rounded-2xl px-6 py-3 font-semibold border"
              style={{ borderColor: 'var(--border)', color: 'var(--foreground)' }}>
          العودة للرئيسية
        </Link>
      </div>
    </div>
  );
}
